var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-dropdown',{staticStyle:{"float":"right","cursor":"pointer"},attrs:{"vs-custom-content":"","vs-trigger-click":""}},[_c('vs-button',{attrs:{"color":"primary","type":"border","icon-pack":"feather","icon":"icon-more-vertical"}}),_c('vs-dropdown-menu',[_c('vs-dropdown-item',{on:{"click":_vm.haldleDelete}},[_vm._v("Delete")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }